import React from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import Grid from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import { withStyles } from "@mui/styles";
import { Translation } from "react-i18next";

class Wizard extends React.Component {
  static Page = ({ children }) => children;

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      values: props.initialValues.reduce(
        (acc, curr) => ({ ...acc, ...curr }),
        {},
      ),
    };
  }

  next = (values) => {
    this.setState((state) => ({
      page: Math.min(state.page + 1, this.props.children.length - 1),
      values,
    }));
  };

  previous = () =>
    this.setState((state) => ({
      page: Math.max(state.page - 1, 0),
    }));

  validate = () => {
    const activePage = React.Children.toArray(this.props.children)[
      this.state.page
    ];
    return activePage.props.schema ? activePage.props.schema : {};
  };

  handleSubmit = (values, form) => {
    const { children, onSubmit } = this.props;
    const { page } = this.state;
    const isLastPage = page === React.Children.count(children) - 1;
    if (isLastPage) {
      return onSubmit(values, form);
    } else {
      const nextPage = page + 1;
      const nextValues = this.props.initialValues[nextPage];
      const touched = Object.keys(nextValues).reduce(
        (fields, field) => ({ ...fields, [field]: false }),
        {},
      );
      form.setTouched(touched);
      this.next(values);
      form.setSubmitting(false);
    }
  };

  render() {
    const { children } = this.props;
    const { page, values } = this.state;
    const activePage = React.Children.toArray(children)[page];
    const isLastPage = page === React.Children.count(children) - 1;
    return (
      <Translation>
        {(t) => (
          <Formik
            initialValues={values}
            enableReinitialize={false}
            validationSchema={this.validate}
            onSubmit={this.handleSubmit}
          >
            {({
              values,
              handleSubmit,
              isSubmitting,
              errors,
              handleChange,
              status,
              touched,
              setFieldValue,
              setFieldTouched,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Grid container direction="column">
                  <Grid>
                    {React.cloneElement(activePage, {
                      values,
                      errors,
                      handleChange,
                      status,
                      touched,
                      setFieldValue,
                      setFieldTouched,
                    })}
                  </Grid>
                  <Grid style={{ marginTop: this.props.theme.spacing(2) }} item>
                    <Grid container direction="row" alignItems="center">
                      <Grid item style={{ display: "flex", gap: 8 }}>
                        {page > 0 && (
                          <Button className={this.props.classes.button} type="button" onClick={this.previous}>
                            « {t("offer_create.prev_btn")}
                          </Button>
                        )}
                        <Button className={this.props.classes.button} type="button" onClick={this.props.onCancel}>
                          {t("offer_create.cancel_btn")}
                        </Button>
                      </Grid>

                      <Grid item>
                        <Button
                          disabled={isSubmitting}
                          type="submit"
                          variant="contained"
                          color="primary"
                        >
                          {isLastPage
                            ? t("offer_create.submit_btn")
                            : t("offer_create.next_btn")}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        )}
      </Translation>
    );
  }
}

Wizard.propTypes = {
  initialValues: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const styles = (theme) => ({
  button: {
    marginRight: theme.spacing(1),
    fontWeight: "bold",
    fontSize: "0.875rem",
  },
});

export default withStyles(styles, { withTheme: true })(Wizard);
